gx-designer-tool-drag {
  cursor: move;

  .button-icon-drag {
    padding-inline-start: 0px;
    border: 0px;
  }
}
